import PropTypes from 'prop-types';
import React from 'react';

import './SearchContainer.scss';

export default class SearchContainer extends React.PureComponent {
    constructor(props) {
        super(props);
    }

    static propTypes = {
        /**
         * node of children in search container form
         */
        children: PropTypes.node.isRequired,
    };

    render() {
        return (
            <div className="component-Resources-SearchContainer">
                <form onReset={this.props.onReset}>{this.props.children}</form>
            </div>
        );
    }
}
